module.exports = __webpack_public_path__ + "img/Logo_border.ee6ff77c.jpg";